import { defineModule } from "direct-vuex";
import { moduleActionContext } from "@/store";
import { FILTER_NAMES } from "@/static/filterNames";
import CriterionItemRequest from "@/models/api/filters/criterions/CriterionItemRequest";
import { getBookingFiles, getPreviewBookingFile } from "@/requests/booking";
import { BookingFilesListItem } from "@/models/api/bookings/BookingFilesListItem";
import { DataOptions } from "vuetify";
import { DefaultDataOptions } from "@/models/components/dataTables/DataTableOptions";
import { isHiddenError } from "@/models/ErrorHiddenFromConsole";

export interface AdministrationBookingFilesInterface {
  bookingFilesFilters: Array<CriterionItemRequest> | null;
  bookingFilesTableData: Array<BookingFilesListItem>;
  bookingFilesTableOptions: DataOptions;
  bookingFilesTableCount: number;
  isDialog: boolean;
  isLoading: boolean;
  fileData: string | null;
}

export const AdministrationBookingFilesState: AdministrationBookingFilesInterface = {
  bookingFilesFilters: null,
  bookingFilesTableData: [],
  bookingFilesTableOptions: new DefaultDataOptions(),
  bookingFilesTableCount: -1,
  isLoading: true,
  isDialog: false,
  fileData: null,
};

const AdministrationBookingFilesModule = defineModule({
  state: AdministrationBookingFilesState as AdministrationBookingFilesInterface,
  namespaced: true as const,
  modules: {},
  getters: {},
  mutations: {
    setBookingFilesFilters(state, param: Array<CriterionItemRequest> | null) {
      state.bookingFilesFilters = param;
    },
    setBookingFilesTableData(state, param: Array<BookingFilesListItem>) {
      state.bookingFilesTableData = param;
    },
    setBookingFilesTableOptions(state, param: DataOptions) {
      state.bookingFilesTableOptions = param;
    },
    setBookingFilesTableCount(state, param: number) {
      state.bookingFilesTableCount = param;
    },
    setIsLoading(state, param: boolean) {
      state.isLoading = param;
    },
    setIsDialog(state, param: boolean) {
      state.isDialog = param;
    },
    setFileData(state, param: string) {
      state.fileData = param;
    },
  },
  actions: {
    async downloadBookingFiles(context) {
      const { commit, state } = _moduleActionContext(context);
      commit.setIsLoading(true);
      const bookingFiles = await getBookingFiles({
        count: state.bookingFilesTableOptions.itemsPerPage,
        page: state.bookingFilesTableOptions.page - 1,
        criterions: state.bookingFilesFilters,
        filterName: FILTER_NAMES.BookingDataListStandardFilter,
      }).catch((err) => {
        if (isHiddenError(err)) return null;
        commit.setIsLoading(false);
        return null;
      });

      if (bookingFiles != null) {
        commit.setBookingFilesTableData(bookingFiles.items);
        commit.setBookingFilesTableCount(bookingFiles.totalCount);
        commit.setIsLoading(false);
      }
    },
    async preview(
      context,
      param: {
        bookingDataId: number;
      }
    ) {
      const { commit } = _moduleActionContext(context);
      const response = await getPreviewBookingFile(param.bookingDataId);
      commit.setFileData(response);
    },
  },
});

export default AdministrationBookingFilesModule;

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
const _moduleActionContext = (context: any) =>
  moduleActionContext(context, AdministrationBookingFilesModule);
